<template>
    <div class="pagination mg_top_50" data-aos="fade-up" v-if="counts > 1">
        <a class="nav-btn nav-double-prev" :class="{'disabled': current <= 1}" @click.prevent="setPage(1)" href="javascript:;">
            <i class="fas fa-angle-double-left"></i>
        </a>
        <a class="nav-btn nav-prev" :class="{'disabled': current <= 1}" @click.prevent="setPage(current - 1)" href="javascript:;">
            <i class="fas fa-angle-left"></i><span>PREVIOUS</span>
        </a>
        <ul class="nav-pages">
            <li v-for="page in pages"><a :class="{'active': page === current}" @click.prevent="setPage(page)" href="javascript:;">{{ page }}</a></li>
        </ul>
        <a class="nav-btn nav-next" :class="{'disabled': current >= counts}" @click.prevent="setPage(current + 1)" href="javascript:;">
            <span>NEXT</span><i class="fas fa-angle-right"></i>
        </a>
        <a class="nav-btn nav-double-next" :class="{'disabled': current >= counts}" @click.prevent="setPage(counts)" href="javascript:;">
            <i class="fas fa-angle-double-right"></i>
        </a>
    </div>
</template>

<script>
    export default {
        name: "WeyaPagination",
        props: {
            initialPage: {
                type: Number,
                default: 1
            },
            counts: {
                type: Number,
                default: 10
            }
        },
        data: () => {
            return {
                current: 1,
                pages: [],
                pageSize: 5
            };
        },
        watch: {
            counts: function (newVal, oldVal) {
                this.sliderPage();
            },
        },
        created() {
            this.current = this.initialPage;
            this.sliderPage();
        },
        methods: {
            sliderPage() {
                this.pages = [];
                if (this.counts <= this.pageSize) {
                    for (let i = 1; i <= this.counts; i++) {
                        this.pages.push(i);
                    }
                } else {
                    let maxPagesBeforeCurrentPage = Math.floor(this.pageSize / 2);
                    let maxPagesAfterCurrentPage = Math.ceil(this.pageSize / 2) - 1;

                    let startPage = 1;
                    let endPage = this.counts;

                    if (this.current <= maxPagesBeforeCurrentPage) {
                        startPage = 1;
                        endPage = this.pageSize;
                    } else if (this.current + maxPagesAfterCurrentPage >= this.counts) {
                        startPage = this.counts - this.pageSize + 1;
                        endPage = this.counts;
                    } else {
                        startPage = this.current - maxPagesBeforeCurrentPage;
                        endPage = this.current + maxPagesAfterCurrentPage;
                    }

                    for (startPage; startPage <= endPage; startPage++) {
                        this.pages.push(startPage);
                    }
                }
            },
            setPage(page) {
                if (this.current !== page && page !== 0 && page !== (this.counts + 1)) {
                    this.current = page < 1 ? 1 : (page > this.counts ? this.counts : page);
                    this.sliderPage();
                    this.$emit('change-page', this.current);
                }
            }
        }
    }
</script>
